import { Tabs } from "antd";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ListBusinessUnit from "./businessUnit/ListBusinessUnit/ListBusinessUnit";
import ListGroupBusinessUnit from "./groupBu/ListGroupBusinessUnit/ListGroupBusinessUnit";
import ActionButtonGradient from "../../components/button/ActionButtonGradient";

const BuManagement = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [activeTab, setActiveTab] = useState('1');

    const handleTabChange = (key) => {
        setActiveTab(key);
        navigate(`/bu-management/${key}`);
    };

    useEffect(() => {
        if (params.tab_order) {
            setActiveTab(params.tab_order);
        }
    }, [params.tab_order]);

    const items = [
        {
          key: '1',
          label: `Group Business Unit`,
          children: <ListGroupBusinessUnit hideCreateButton={true} />
        },
        {
          key: '2',
          label: `Business Unit`,
          children: <ListBusinessUnit hideCreateButton={true} />
        },
    ]

    const [tabItems, setTabItems] = useState(items)

    const handleCreateClick = () => {
        if (activeTab === '1') {
            navigate('/bu-management/gbu-form');
        } else {
            navigate('/bu-management/bu-form');
        }
    };

    const getButtonText = () => {
        return activeTab === '1' ? 'Create Group Business Unit' : 'Create Business Unit';
    };

    return (
        <div className="container-fluid justify-content-center" style={{ 
            maxWidth: '1200px', 
            margin: '0 auto',
            width: '100%',
        }}>
            <div style={{
                backgroundColor: '#ffffff',
                borderRadius: '12px',
                padding: '24px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0'
            }}>
                <div className="mb-3" style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center', 
                }}>
                    <h5 style={{ 
                        margin: 0,
                        fontWeight: 600,
                        color: '#1a1a1a',
                        fontSize: '18px'
                    }}>
                        Business Unit Management
                    </h5>
                    <ActionButtonGradient
                        onClick={handleCreateClick}
                        variant="success"
                        children={getButtonText()}
                    />

                </div>
                <Tabs
                    activeKey={activeTab}
                    tabPosition={"top"}
                    items={tabItems}
                    onChange={handleTabChange}
                />
            </div>
        </div>
    )
}

export default BuManagement